// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ContactMethod } from './contact-method';
import { ContactType } from './contact-type';
import { Dealer } from './dealer';
import { OrderLineDetail } from './order-line-detail';
import { Vendor } from './vendor';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ContactLog extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  companyName?: string;
  contactMethodId!: number;
  contactName?: string;
  contactTypeId!: number;
  created!: Date;
  createdBy?: string;
  dealerId?: number;
  deleted?: Date;
  deletedBy?: string;
  email?: string;
  note?: string;
  noteDate!: Date;
  orderLineDetailId?: number;
  phoneNumber?: string;
  reason?: string;
  resolution?: string;
  vendorId?: number;
  contactMethod!: ContactMethod;
  contactType!: ContactType;
  dealer!: Dealer;
  orderLineDetail!: OrderLineDetail;
  vendor!: Vendor;
}

